var isArrayLikeObject = require('./isArrayLikeObject');

/**
 * Casts `value` to an empty array if it's not an array like object.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {Array|Object} Returns the cast array-like object.
 */
function castArrayLikeObject(value) {
  return isArrayLikeObject(value) ? value : [];
}

module.exports = castArrayLikeObject;



//////////////////
// WEBPACK FOOTER
// ./~/lodash/_castArrayLikeObject.js
// module id = 355
// module chunks = 35783957827783 114276838955818